import { ContactsCard, DagestanContactsCard } from './contacts';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from './i18n';
import './App.css';

const logo = process.env.PUBLIC_URL + '/images/logo.png';

function BuyRussiaPage() {
  const { href, messages } = useLanguage();
  const copy = messages.order;

  return (
    <div className="page">
      <header className="hero hero-compact">
        <nav className="topbar" aria-label={messages.navigation}>
          <a className="brand" href={href('/')} aria-label={messages.brandPlain}>
            <img src={logo} className="brand-logo" alt={messages.logoAlt} />
            <span>{messages.brand}</span>
          </a>
          <LanguageSwitcher />
        </nav>
      </header>

      <main>
        <section className="section buy-page">
          <a className="back-link" href={href('/')}>
            ← {messages.home}
          </a>

          <div className="section-heading">
            <p className="eyebrow">{copy.russiaRegion}</p>
            <h1 className="buy-page-title">{copy.russiaTitle}</h1>
            <p className="hero-lead">{copy.russiaIntro}</p>
          </div>

          <div className="buy-contacts-stack">
            <section className="contact-section">
              <div>
                <p className="eyebrow">{copy.seller}</p>
                <h2>{copy.sellerCompany}</h2>
              </div>
              <ContactsCard />
            </section>

            <section className="contact-section">
              <div>
                <p className="eyebrow">{copy.dagestan}</p>
                <h2>{copy.pharmacy}</h2>
                <p className="hero-lead">{copy.pharmacyNote}</p>
              </div>
              <DagestanContactsCard />
            </section>
          </div>
        </section>

        <section className="notice">
          <strong>{messages.important}</strong> {messages.disclaimer}
        </section>
      </main>
    </div>
  );
}

export default BuyRussiaPage;
